import { render } from "./trade-history.vue?vue&type=template&id=ee5de988"
import script from "./trade-history.vue?vue&type=script&lang=js"
export * from "./trade-history.vue?vue&type=script&lang=js"

import "./trade-history.vue?vue&type=style&index=0&id=ee5de988&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__